import { TRAFFIC_LIGHT_LABELS, type TrafficLight } from '@fluxus/shared';
import {
  AlertTriangle,
  CalendarClock,
  CheckCircle2,
  CircleDashed,
  XOctagon,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/cn';

const ICONS: Record<TrafficLight, LucideIcon> = {
  green: CheckCircle2,
  yellow: AlertTriangle,
  red: XOctagon,
  gray: CircleDashed,
  blue: CalendarClock,
};

const STYLES: Record<TrafficLight, string> = {
  green: 'bg-status-green-bg text-status-green-fg',
  yellow: 'bg-status-yellow-bg text-status-yellow-fg',
  red: 'bg-status-red-bg text-status-red-fg',
  gray: 'bg-status-gray-bg text-status-gray-fg',
  blue: 'bg-status-blue-bg text-status-blue-fg',
};

export const STATUS_DOT: Record<TrafficLight, string> = {
  green: 'bg-status-green-solid',
  yellow: 'bg-status-yellow-solid',
  red: 'bg-status-red-solid',
  gray: 'bg-status-gray-solid',
  blue: 'bg-status-blue-solid',
};

type StatusBadgeProps = {
  status: TrafficLight;
  /** Texto no lugar do rótulo padrão (ex.: "Banco de dados indisponível"). */
  label?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Status do semáforo: sempre cor + ícone + texto (nunca só cor). */
export function StatusBadge({ status, label, size = 'sm', className }: StatusBadgeProps) {
  const Icon = ICONS[status];
  return (
    <span
      data-status={status}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-semibold whitespace-nowrap',
        size === 'sm' ? 'px-2.5 py-0.5 text-xs [&_svg]:size-3.5' : 'px-3 py-1 text-sm [&_svg]:size-4',
        STYLES[status],
        className,
      )}
    >
      <Icon aria-hidden />
      {label ?? TRAFFIC_LIGHT_LABELS[status]}
    </span>
  );
}
